import React from 'react'
import './Nevbar.css'
export default function Nevbar() {
    return (
        <div>
            <ul>
                <li><a href="/Home">Home</a></li>
                <li><a href="/About">About</a></li>
                <li><a href="/Product">Product</a></li>
                <li><a href="/Service">Service</a></li>
                <li><a href="/Contact">Contact</a></li>

            </ul>
        </div>

    )
}
